
export class BarItemModel {
    title: string = "";
    internalfilters: string[] = [];
    description: string = "Example Text";
    filterName: string = ""
    displaySelected: boolean = false;

    constructor(title: string, internalFilters: string[], desciption: string, filterName: string, displaySelected: boolean) {
        this.title = title;
        this.internalfilters = internalFilters;
        this.description = desciption;
        this.filterName = filterName;
        this.displaySelected = displaySelected;
    }
}